async function reportTreasureFound({ treasureId, userId, comment, photo }) {
  const formData = new FormData();
  const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";
  formData.append("treasure_id", treasureId);
  formData.append("userId", userId);
  formData.append("message", comment);
  if (photo) formData.append("photo", photo);
  const resp = await fetch(`${API_BASE_URL}/api/treasure/report`, {
    method: "POST",
    body: formData,
  });
  return await resp.json();
}

export default reportTreasureFound;
